export const englishTexts = {
  continue: "Continue",
  loginButton: "Mail log in",
  registerButton: "Sing in",
  emailField: "email",
  passField: "Password",
  warnEmailField: "Please enter your email",
  warnPassField: "Please enter your password",
  warnPassFormat: "Password must contain: ",
  warnPassUpper: "upper case",
  warnPassLower: "lower case",
  warnPassNumber : "number",
  warnPassChar: "special character",
  warnPassLong: "at least 12 characters",
  warnConfirmPassField: "Confirm password",
  errorLogin: "Incorrect email or password",
  errorSingUp: "Problem with user registration",
  warnLogin: "Could not connect. Please try again later",
  warnEmailLogin: "Invalid e-mail format",
  warnPassLogin: "Invalid password format",
  warnPassDiff: "Passwords do not match",
  confirmPassField: "Confirm Password",
  access: "Log in",
  recoverPass: "Password recovery",
  createAccount: "Create account",
  acceptTerms: "Agree to terms and conditions",
  createFormTitle: "Enter the following information to create your account: ",
  didntReceiveEmail: "Did you not receive the confirmation e-mail?",
  sendAgain: "Submit again",
  goLogin: "Go to Login",
  modalVerifyEmail: "We send you an email for account verification",
  recoverPassEmailTitle: "Please enter an e-mail to recover your password",
  recoverPassTitle: "Enter your new password",
  recoverPassButton: "Recover",
  recoverPassMsg: "We sent you and email with instructions to recover your password",
  recoverPassPass: "Enter a new password to your account",
  recoverPassSave: "Save",
  passFormat: "Password must be at least 12 characters long and contain one upper and one lower case letters, one special character and a number",
  termsTitle: "Terms and conditions",
  termsSubTitle: "Privacy policy",
  termsText: "Lorem ipsum odor amet, consectetuer adipiscing elit. Urna hendrerit sociosqu eget augue iaculis conubia at. Fames iaculis proin nam lorem elit nullam. Conubia primis suspendisse sodales placerat eleifend varius libero condimentum venenatis. At phasellus fusce himenaeos dolor cras sociosqu interdum torquent. Lacus nullam dui maximus; platea tempus augue. Volutpat ornare condimentum elementum netus massa curae enim. Eleifend interdum vivamus eros cursus ante ridiculus elementum in. Tristique sagittis scelerisque volutpat quisque sollicitudin non placerat class.\n" +
    "\n" +
    "Hendrerit turpis cursus urna a vitae; erat placerat elit. Consequat ridiculus congue cras adipiscing mauris cras. Per leo efficitur urna malesuada ullamcorper nullam mus aliquet. Egestas velit donec nisl facilisis hendrerit odio laoreet. Inceptos mollis penatibus adipiscing accumsan laoreet. Litora varius nostra sociosqu ornare, libero cursus. Sit semper class lobortis porta imperdiet convallis habitant eu venenatis. Sodales nulla aliquam bibendum, vivamus laoreet fringilla. Mus donec tristique a quam inceptos condimentum.\n" +
    "\n" +
    "Arcu mollis mollis elementum parturient conubia dui facilisi. Aliquam aliquet malesuada libero est elit. Felis leo dignissim pretium ullamcorper vel accumsan ornare interdum. Nostra ex sagittis litora vivamus senectus proin enim rhoncus dis. Aptent leo vivamus molestie, blandit vivamus posuere pellentesque. Aptent felis finibus elementum gravida praesent non elit enim. Litora dis maximus egestas consectetur mollis. Felis adipiscing posuere cursus imperdiet per quam."
}